import { render } from "./lightbox.vue?vue&type=template&id=9a5579c2&scoped=true"
import script from "./lightbox.vue?vue&type=script&lang=js"
export * from "./lightbox.vue?vue&type=script&lang=js"

import "./lightbox.vue?vue&type=style&index=0&id=9a5579c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9a5579c2"

export default script